import { AccountId } from '../generated-types';
import useQueryParam from './useQueryParam';

const useAccountId = (): AccountId | undefined => {
    return useQueryParam('id');
};
export default useAccountId;
